import { render, staticRenderFns } from "./NewStudentDashboard.vue?vue&type=template&id=649c7958&scoped=true"
import script from "./NewStudentDashboard.vue?vue&type=script&lang=js"
export * from "./NewStudentDashboard.vue?vue&type=script&lang=js"
import style0 from "./NewStudentDashboard.vue?vue&type=style&index=0&id=649c7958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c7958",
  null
  
)

export default component.exports